var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1,16c-1.3,0-2.6-0.5-3.6-1.4c-1.9-1.8-2-4.8-0.3-6.7c0.1-0.1,0.2-0.2,0.3-0.3L8.6,1c1.4-1.3,3.7-1.3,5.1,0 c0.7,0.6,1,1.4,1.1,2.3c0,0.9-0.3,1.7-0.9,2.4c-0.1,0.1-0.1,0.1-0.2,0.2l-7.1,6.6c-0.8,0.8-2.1,0.8-2.9,0c-0.8-0.7-0.8-1.9-0.1-2.7 c0,0,0.1-0.1,0.1-0.1l6.5-6.1c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8l-6.5,6.1c-0.4,0.4-0.3,0.9,0,1.3c0.4,0.4,1,0.4,1.4,0 l7.1-6.6C13,5,13,5,13.1,4.9c0.4-0.4,0.6-1,0.6-1.6c0-0.6-0.3-1.2-0.7-1.6c-1-0.9-2.6-0.9-3.6,0L2.3,8.4C2.2,8.5,2.1,8.6,2,8.6 c-1.4,1.5-1.3,3.8,0.2,5.1c1.6,1.5,4.2,1.5,5.8,0l7.1-6.6c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8l-7.1,6.6 C7.8,15.5,6.4,16,5.1,16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.d7b90e6a8e536afb077bcc6b4d22fa0f.svg";
export { ForwardRef as ReactComponent };